jQuery(document).ready(function ($)
{
	let currentIndex = 0;
	let totalSteps   = $('[data-process-step]').length;
	let interval     = null;
	let delay        = 8000; // time per step (adjust as needed, but must match `transition-duration` in our-process.scss)

	// CORE FUNCTION
	function goToStep(index) {

		currentIndex = index;

		const $currentStep = $('[data-process-step="' + index + '"]');
		const $currentImg = $('[data-step-img="' + index + '"]');

		// Steps
		$('[data-process-step]').removeClass('is-active');
		$currentStep.addClass('is-active');

		// Text (animate)
		$('[data-process-text]').stop(true, true).slideUp(300);
		$currentStep.find('[data-process-text]').stop(true, true).slideDown(300);

		// Images (fade)
		$('[data-step-img]')
			.removeClass('is-active')
			.stop(true, true)
			.fadeOut(300);

		$currentImg
			.addClass('is-active')
			.stop(true, true)
			.fadeIn(300);

		$('.process-step').removeClass('is-active-progress');
		setTimeout(() => {
			$currentStep.addClass('is-active-progress');
		}, 10);
	}

	// AUTO LOOP
	function startAutoLoop() {
		stopAutoLoop(); // prevent duplicates

		interval = setInterval(function () {
			let nextIndex = (currentIndex + 1) % totalSteps;
			goToStep(nextIndex);
		}, delay);
	}

	function stopAutoLoop() {
		if (interval) {
			clearInterval(interval);
			interval = null;
		}
	}

	// INIT
	$('[data-process-text]').hide();
	$('[data-step-img]').hide();

	goToStep(0);
	startAutoLoop();

	// CLICK (manual override)
	$(document).on('click', '[data-process-heading]', function () {

		const index = $(this).data('process-heading');

		goToStep(index);

		// restart timer after manual interaction
		startAutoLoop();
	});

	// HOVER PAUSE
	$('.process__steps').on('mouseenter', function () {
		stopAutoLoop();
	});

	$('.process__steps').on('mouseleave', function () {
		startAutoLoop();
	});

});